import { FeedItem } from 'components/context/types';

export enum ArticleListType {
    TALENTNEWS,
    SOCIALMEDIA,
    APPOINTMENT,
    JOBS,
    UNDEFINED
}

export interface ArticleList {
    title: string;
    articleListType: ArticleListType;
}

export type BusinessFeedItem = {
    articleListType: ArticleListType;
} & FeedItem;

export function feedItemToBusinessFeedItem(
    feedItem: FeedItem
): BusinessFeedItem {
    return {
        ...feedItem,
        articleListType: sourceToArticleListType(feedItem.source)
    };
}

function sourceToArticleListType(source?: string): ArticleListType {
    switch (source) {
        case 'kl':
            return ArticleListType.TALENTNEWS;
        case 'te':
            return ArticleListType.TALENTNEWS;
        case 'ap':
            return ArticleListType.TALENTNEWS;
        case 'mm':
            return ArticleListType.TALENTNEWS;
        case 'mb':
            return ArticleListType.TALENTNEWS;
        case 'tv':
            return ArticleListType.TALENTNEWS;
        case 'Twitter':
            return ArticleListType.SOCIALMEDIA;
        case 'Facebook':
            return ArticleListType.SOCIALMEDIA;
        case 'Appointment':
            return ArticleListType.APPOINTMENT;
        case 'monster':
            return ArticleListType.JOBS;
        case 'tepalvelut':
            return ArticleListType.JOBS;
        default:
            return ArticleListType.UNDEFINED;
    }
}
